import React from 'react';
import Reflux from 'reflux';
import createReactClass from 'create-react-class';

import store from '../stores/stand-tooltip-store';

export default createReactClass({
	mixins: [Reflux.connect(store, 'data')],

	render: function () {
		const data = this.state.data;
		if (data) {
			const props = data.properties;
			return (
				<div className="bssp-stand-tooltip">
					<span>{props ? props.name : ''}</span>
				</div>
			);
		} else {
			return <div />;
		}
	},
});
